export const setContentAndFocusStart = (editor, content) => {
  if (!editor) return;

  editor.setContent(content);
  editor.focus();
  editor.selection.select(editor.getBody(), true);
  editor.selection.collapse(true);
};

export default setContentAndFocusStart;
